import { CpmChip } from '../../../components/design-system';
import { applyWritesLine } from '../configTemplateCopy';

interface OverlayPreviewProps {
    labels: string[];
    count: number;
}

export default function OverlayPreview({ labels, count }: OverlayPreviewProps) {
    const shown = labels.slice(0, 8);
    const more = Math.max(0, count - shown.length);
    return (
        <div
            style={{
                padding: '8px 20px',
                borderBottom: '1px solid var(--cpm-border-default)',
                background: 'var(--cpm-purple-tint-3)',
            }}
        >
            <div
                style={{
                    fontSize: 12.5,
                    fontWeight: 800,
                    color: 'var(--cpm-text-primary)',
                    marginBottom: 5,
                }}
            >
                {applyWritesLine(count)}
            </div>
            <div className="flex flex-wrap" style={{ gap: 5 }}>
                {shown.map((label, index) => (
                    <CpmChip key={`${label}-${index}`} variant="tag">
                        {label}
                    </CpmChip>
                ))}
                {more > 0 ? (
                    <span
                        style={{
                            fontSize: 11.5,
                            fontWeight: 700,
                            color: 'var(--cpm-text-secondary)',
                            alignSelf: 'center',
                        }}
                    >
                        +{more} more
                    </span>
                ) : null}
            </div>
        </div>
    );
}
